export const globalSharedAU = {
  timezones: {
    zone: 'AEST',
    travelDates: 'All travel dates are in AEST',
  },
} as const;
